/**
 * Mockup-aligned HP heart markup for DOM hp-pill rows (day.html / night.html).
 */

var HEART_D = "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z";

/** @see index.html hidden <defs> — single document-wide gradient id. */
export var HP_HEART_FILL_GRAD_ID = "hpHeartFillGrad";

/**
 * @param {number} maxHp
 * @param {number} hp
 * @param {{ healSlot?: boolean, uid?: number }} [opts]
 * healSlot: show + on the next missing heart from the left (no extra heart).
 * @returns {string}
 */
export function renderHpHeartsHtml(maxHp, hp, opts) {
  opts = opts || {};
  var max = Math.max(1, Math.floor(Number(maxHp) || 3));
  var cur = Math.max(0, Math.min(max, Math.floor(Number(hp) || 0)));
  var html = "";
  for (var i = 0; i < max; i++) {
    var filled = i < cur;
    var isHealTarget = !!opts.healSlot && !filled && i === cur;
    html += '<span class="hp-heart'
      + (filled ? " hp-heart--filled" : " hp-heart--empty")
      + (isHealTarget ? " hp-heart--heal-slot" : "")
      + '">';
    if (isHealTarget) {
      html += '<span class="hp-heart__icon">';
    }
    html += '<svg class="hp-heart__svg" viewBox="0 0 24 24" aria-hidden="true">';
    if (filled) {
      html += '<path class="hp-heart__depth" d="' + HEART_D + '" transform="translate(0.9,1.1)"/>';
      html += '<path class="hp-heart__body" fill="url(#' + HP_HEART_FILL_GRAD_ID + ')" d="' + HEART_D + '"/>';
      html += '<path class="hp-heart__rim" d="' + HEART_D + '"/>';
      html += '<path class="hp-heart__shine" d="M8 7.5C9.2 6.2 11 5.8 12.2 6.8 12.6 7.1 12.5 7.8 11.9 8.1 10.8 8.6 9.4 8.3 8.4 7.5 8.1 7.2 8 7 8 7.5Z"/>';
    } else {
      html += '<path class="hp-heart__body" d="' + HEART_D + '"/>';
      html += '<path class="hp-heart__rim" d="' + HEART_D + '"/>';
    }
    html += "</svg>";
    if (isHealTarget) {
      html += '<span class="hp-heart__plus" aria-hidden="true">+</span>';
      html += "</span>";
    }
    html += "</span>";
  }
  return html;
}